var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkZones({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a/icons/micro/16/earth-lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a/icons/micro/16/earth-lock",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66666667,2.22666667 L4.66666667,3.33333333 C4.66666667,4.43790283 5.56209717,5.33333333 6.66666667,5.33333333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333333,14.6333333 L7.33333333,12 C7.33333333,11.2636203 6.73637967,10.6666667 6,10.6666667 C5.26362033,10.6666667 4.66666667,10.069713 4.66666667,9.33333333 L4.66666667,8.66666667 C4.66666667,7.930287 4.069713,7.33333333 3.33333333,7.33333333 L1.36666667,7.33333333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.36,10 L11.3333333,10 C10.5969537,10 10,10.5969537 10,11.3333333 L10,14.36",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1.33333333 C4.57987894,1.33354127 1.71469315,3.92182699 1.36806602,7.32433749 C1.02143889,10.726848 3.30582321,13.8397407 6.65564146,14.529629 C10.0054597,15.2195173 13.3339637,13.2625876 14.36,10",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,4 L13.3333333,2.66666667 C13.3333333,1.930287 12.7363797,1.33333333 12,1.33333333 C11.2636203,1.33333333 10.6666667,1.930287 10.6666667,2.66666667 L10.6666667,4",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.33333333,
    y: 4,
    width: 5.33333333,
    height: 3.33333333,
    rx: 0.666666687
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkZones);
export default __webpack_public_path__ + "static/media/network-zones.41e11607238d6ee2fccd5ede5dde6e43.svg";
export { ForwardRef as ReactComponent };